module.exports = __webpack_public_path__ + "ff54103e8a4a8e73d9b18bf94b39afd0.pdf";